export default __webpack_public_path__ + "static/media/photo--lg--104.553fd02a.jpg";